export default __webpack_public_path__ + "static/media/BrainBreak cards79.53f35a53.png";